export default __webpack_public_path__ + "static/media/sealife5.97456014.jpg";